import React from "react";

/**
 * @todo Convenience: create a ModalButton that is aware of the modal's state
 * via this context. If a submission is in progress, you could more easily
 * disable the entire modal and buttons can no longer be clicked. */
export const FormContext = React.createContext({
  disabled: false,
});
